import { connect } from 'react-redux'
import { toggleDrawer, toggleAppbarWhiteFont, getOrganization, getEnumeration, CreatePos, GetOrgPos, GetPos, clearOrgPOS } from '../actions'
import PaymentTerminals from '../components/PaymentTerminals'

const mapStateToProps = state => ({
    openDrawer: state.navDrawers.isOpen,
    appbarIsWhiteFont: state.appBars.appbarIsWhiteFont,
    organization: state.organizations.organization,
    enumeration: (state.misc.enum) || {},
    paymentterminalsread: (state.organizations.role && state.organizations.role.paymentterminalsread) || false,
    paymentterminalswrite: (state.organizations.role && state.organizations.role.paymentterminalswrite) || false,
    organizationPos: state.organizations.organizationPos || [],
    detailedPos: state.organizations.detailedPos || {},
    detailedPosRoutes: state.organizations.detailedPos || {},
    environment: state.appstate.environment || 'staging',
})

const mapDispatchToProps = dispatch => ({
    toggleDrawer: () => dispatch(toggleDrawer()),
    toggleAppbarWhiteFont: (isWhite) => dispatch(toggleAppbarWhiteFont(isWhite)),
    getOrganization: (params) => dispatch(getOrganization(params)),
    getEnumeration: (params) => dispatch(getEnumeration(params)),
    CreatePos: (params, reqBody) => dispatch(CreatePos(params, reqBody)),
    GetOrgPos: (params, query) => dispatch(GetOrgPos(params, query)),
    GetPos: (params) => dispatch(GetPos(params)),
    clearOrgPOS: (params) => dispatch(clearOrgPOS(params))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentTerminals)